import React from 'react';

import { PostHogProvider } from 'third-party';

import { posthogOptions } from 'constants/common';

export const PostHogWrapper = ({ children }: { children: React.ReactNode }) => {
  if (!process.env.POSTHOG_KEY) {
    return <>{children}</>;
  }

  return (
    <PostHogProvider apiKey={process.env.POSTHOG_KEY} options={posthogOptions}>
      {children}
    </PostHogProvider>
  );
};
